<template>
  <div class="accordion">
    <div v-for="(item, key) in items" :key="key" class="accordion__item" @click="toggleShowList(key)">
      <div class="main-description-details-title">
        <span :class="{'text-bold': selectedItems.includes(key)}">{{ item.name }}</span>
        <div class="main-description-details-title-right">
          <span :class="{'color-active': selectedItems.includes(key)}">{{ item.accessories.length }}</span>
          <IconArrow color="#afafaf" :rotate="selectedItems.includes(key) ? 'up' : 'down'"/>
        </div>
      </div>
      <EquipmentPack
          :isOld="isOld"
          :carPacks="item.accessories"
          :icon="true"
          v-show="selectedItems.includes(key)"
          class="main-description-details-content"
      />
    </div>
  </div>
</template>

<script>
import IconArrow from "@/components/svg/ArrowLeft";
import EquipmentPack from "@/components/Dealers/DealerPack"

export default {
  components: {
    IconArrow,
    EquipmentPack
  },
  props: {
    isOld:{
      type: Boolean,
      default: false
    },
    items: {
      type: Object,
      default: () => []
    },
    showAll: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    // selectedItem: null,
    selectedItems: []
  }),
  methods: {
    toggleShowList(id) {
      const index = this.selectedItems.indexOf(id);
      this.selectedItems.includes(id)
          ? this.selectedItems.splice(index, 1)
          : this.selectedItems.push(id)
    }
  },
  watch: {
    showAll() {
      if (this.showAll) {
        for (const key in this.items) {
          if (!this.selectedItems.includes(key)) this.selectedItems.push(key)
        }
      } else {
        this.selectedItems = [];
      }
    }
  }
}
</script>
